import { render, staticRenderFns } from "./EditAllowedStudentsDialog.vue?vue&type=template&id=0e9b4e6c&scoped=true&"
import script from "./EditAllowedStudentsDialog.vue?vue&type=script&lang=js&"
export * from "./EditAllowedStudentsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditAllowedStudentsDialog.vue?vue&type=style&index=0&id=0e9b4e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9b4e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
